import {createFileRoute} from '@tanstack/react-router';

import EventCreate from '@/practitioner/views/event/EventCreate/EventCreate';

export const Route = createFileRoute('/(practitioner)/practitioner/events/create')({
  component: EventCreate
});
